import { SliderField } from './SliderField';
import { useNode } from '@craftjs/core';
import type { StylingProps } from '@builder4/shared/types/layout';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';

const NodeOpacitySettings = () => {
  const {
    actions: { setProp },
    props,
    displayName,
  } = useNode((node) => ({
    props: node.data.props,
    displayName: node.data.displayName,
  }));

  const { getBPProp, setBPProp } = useBreakpointAwareProp(displayName);
  const opacity = getBPProp(props, 'opacity') || 0;

  return (
    <SliderField
      label="Opacity"
      value={Math.round(opacity * 100)} // Nico want to have 1-100 range instead of 0-1
      onChange={(e) => {
        setProp((props: Partial<StylingProps>) => {
          setBPProp(props, 'opacity', e / 100);
        }, 500);
      }}
      min={0}
      max={100}
      step={1}
    />
  );
};

export default NodeOpacitySettings;
